import * as React from 'react';
import { useState } from 'react';
import { useRouter } from 'next/router';
import styles from './login.module.css';
import { format } from 'date-fns';
import CelcomLogo from '../../public/resources/logo/logo-celcom-business-reverse_dark.svg';
import FilledButton from '../../components/ReusableComponents/Buttons/FilledButton';
import OutlineButton from '../../components/ReusableComponents/Buttons/OutlineButton';
import TextField from '../../components/ReusableComponents/CustomInput';
import Popover from 'react-bootstrap/Popover';
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import { useEffect } from "react";
// import RegistrationPopup from "../Popup/RegistrationPopup";
import LoadingDailog from '../../Helper/LoadingDailog';
import TermsConditions from '../Popup/TermsConditions';
import PasswordGenerator from '../ReusableComponents/PasswordGenerator/PasswordGenerator';
import Timer from './Timer';
import useHttp from '../../Helper/use-http';
import ErrorHandling from '../ReusableComponents/ErrorHandling/ErrorHandling';
// import { getCookie } from 'cookies-next';
import ErrorApiPopup from '../ReusableComponents/ErrorApiMessage/ErrorApiPopup';
import BulkReceiptReact from '../Popup/BulkReceiptReact';
// import { NEXT_API_URL } from '../../Helper/Config';
// import CryptoJS from 'crypto-js';
import LoginIdGenerator from '../ReusableComponents/LoginIdGenerator/LoginIdGenerator';
import { crypt } from '../../Helper/helper';
import { generateUniqueId } from "../../Helper/generateUniqueId.js";

process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0';

function Registration({ setScreenName }) {
  // const router = useRouter();
  // const urlLink = getCookie('AUTHTOKEN');
  const [isLoading, setIsLoading] = useState(false);
  const [modalIsOpenError, setModalIsOpenError] = useState(false);
  const [modalIsOpenBulk, setModalIsOpenBulk] = useState(false);
  const [modalIsOpenTNC, setModalIsOpenTNC] = useState(false);
  const [errorAPIMessage, setErrorAPIMessage] = useState('');

  const [fName, setFName] = useState('');
  const [lName, setLName] = useState('');
  // const [passcode, setPasscode] = useState();
  // const [passcodeConfirm, setPasscodeConfirm] = useState();
  const [email, setEmail] = useState('');
  const [brn, setBrn] = useState('');
  const [mobileNum, setMobileNum] = useState('');
  const [tacReq, setTacReq] = useState('');
  const [fileBrowse, setFileBrowse] = useState('');
  const [checkbox, setCheckbox] = useState();

  const [errFName, setErrFName] = useState('');
  const [errLName, setErrLName] = useState('');
  // const [errPasscode, setErrPasscode] = useState("");
  const [errPasscodeRule, setErrPasscodeRule] = useState([
    { char: true, capLet: true, smLet: true, minNum: true, minSym: true },
  ]);
  // const [errPasscodeConfirm, setErrPasscodeConfirm] = useState("");
  const [errEmail, setErrEmail] = useState('');
  const [errBrn, setErrBrn] = useState();
  const [errMobileNum, setErrMobileNum] = useState('');
  const [errTacReq, setErrTacReq] = useState('');
  const [errFileBrowse, setErrFileBrowse] = useState('');
  const [errCheckbox, setErrCheckbox] = useState('');

  // const [brnComparingStart, setBrnComparingStart] = useState(false);
  const [resetSingle, setResetSingle] = useState(false);
  const [tacStatus, setTacStatus] = useState(false);
  const [getTAC, setGetTAC] = useState(0);
  const [fileName, setFileName] = useState('');
  const [pdfValue, setPdfValue] = useState('');

  // timer tac
  const [forceTimerGone, setForceTimerGone] = useState(false);
  const [tacAgain, setTacAgain] = useState(false);
  const [timerReset, setTimerReset] = useState(false);

  const [emailExist, setEmailExist] = useState(true);
  // const [userPic, setUserPic] = useState(false);
  // const [roleGroupMap, setRoleGroupMap] = useState(false);
  // const [info, setInfo] = useState([]);
  const [workItemId, setWorkItemId] = useState('');

  // date time formal for payload
  const date = format(new Date(), 'yyyy-MM-dd');
  // const time = format(new Date, 'kk:mm:sss');
  const gmt = new Date().getTimezoneOffset() / -60;
  // let fullDateFormat = `${date}T${time}+0${gmt}:00`;

  const hr = new Date().getHours();
  const hr8 = hr + 8;
  const minSec = format(new Date(), 'mm:sss');
  let fullDateFormat8 = `${date}T${hr8}:${minSec}+0${gmt}:00`;

  // API reusable
  const {
    isLoading: loading1,
    error10,
    sendRequest: seviceNumberApiCheck,
  } = useHttp();

  const { error, sendRequest: sendTaskRequestCreateWorkItem } = useHttp(); //email not exist
  // const { error2, sendRequest: sendTaskRequestCreateUser } = useHttp(); //email exist
  // const { error3, sendRequest: sendTaskRequestUserAddDb } = useHttp(); //both
  // const { error4, sendRequest: sendTaskRequestFetchCustRetrieve } = useHttp(); //cust retrieve
  const { error5, sendRequest: sendTaskRequestTAC } = useHttp(); //request TAC
  const { error6, sendRequest: sendTaskRequestDocRef } = useHttp(); //request TAC
  // const { error7, sendRequest: sendTaskRequestEmailTrigger } = useHttp(); //email trigger
  // const { error8, sendRequest: sendTaskRequestGetCustId } = useHttp(); //get CustId
  const { error9, sendRequest: sendTaskRequestCheckEmailAPI } = useHttp(); //check existing email in API to avoid duplicacy
  // const { error10, sendRequest: sendTaskRequestDBCompany, } = useHttp();
  // console.log("process.env.NEXT_PUBLIC_ENV_SERVICENO_KEY", process.env.NEXT_PUBLIC_ENV_SERVICENO_KEY)
  const uploadFile = (e) => {
    var file = document.getElementById('inputGroupFile01').files[0];
    var reader = new FileReader();
    // console.log(file);
    // console.log(file.type);
    reader.readAsDataURL(file);
    // PasswordGenerator(8);
    reader.onload = async function () {
      // console.log("On load function" + reader.result);
      setPdfValue(reader.result.substring(reader.result.indexOf(',') + 1));
      setFileName(e.name);
    };
  };

  // TAC, generate 6 digit
  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function makeAPICall(url, method, body, headers) {
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: method,
        body: JSON.stringify(body),
        headers: headers,
      })
        .then((response) => response.json())
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  }

  const handleSubmitEmailExist = async (brn) => {
    // console.log("handleSubmitEmailExist");
    setIsLoading(true);

    const loginId = await LoginIdGenerator();

    const oriPwd = PasswordGenerator(8);
    const secretKey = process.env.NEXT_PUBLIC_TEMP_PASSWORD;
    // const password = CryptoJS.AES.encrypt(JSON.stringify(oriPwd), secretKey).toString();
    const password = crypt(secretKey, oriPwd);

    // Make API calls simultaneously
    const createUserAndCompanyName = () => {
      const createUser = makeAPICall(
        '/bizcareui/api/adb2c/createUser',
        'POST',
        {
          department: 'BIZC',
          loginID: loginId,
          password: password,
          status: 'Active',
          mobileNum: mobileNum,
          email: email,
        },
        { 'Content-Type': 'application/json', fromReg: true }
      );
      // const encrypted_textBRN = crypt(
      //     process.env.NEXT_PUBLIC_ENCRYPTION_KEY,
      //     CustID
      // );
      const encrypted_textBRN = crypt(
        process.env.NEXT_PUBLIC_ENCRYPTION_KEY,
        brn.trim()
      );
      const getCompanyNameAPI = makeAPICall(
        '/bizcareui/api/celcomAdmin/activeBrns',
        'POST',
        { brn: [`${brn.trim()}`] },
        { fromReg: true }
      );

      // Wait for both API calls to complete
      Promise.all([createUser, getCompanyNameAPI])
        .then(([response1, response2]) => {
          let companyName = response2?.party?.[0]?.customerName;
          let taxIdentificationNumber =
            response2?.party?.[0]?.partyCharacteristics.find((item) => item.name === "tin")?.value;
          let SSTNumber = response2?.party?.[0]?.partyCharacteristics.find((item) => item.name === "sst")?.value;
          // console.log('Create User IGW => ', response1);
          // console.log('Company Name => ', companyName);

          if (response1.error) {
            setIsLoading(false);
            setIsLoading(false);
            ErrorHandling(data, setErrorAPIMessage, setModalIsOpenError);
          } else if (response1.displayName && companyName){
            let ADB2C_ID = response1?.id;
            databaseAPI(companyName, taxIdentificationNumber, SSTNumber, ADB2C_ID);
          //database pic_users create
          }
          else {
            setIsLoading(false);
            setErrorAPIMessage(
              'Request failed. Please check your user Id and Customer Name'
            );
            setModalIsOpenError(true);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          // console.log('fail => ', error);
          setErrorAPIMessage('Please try again. Error: ' + error);
          setModalIsOpenError(true);
        });
    };

    // // if (!userPic) {
    // //api - igw - adb2c
    // sendTaskRequestCreateUser({
    //     url: '/bizcareui/api/Registration/createUserGetToken',
    //     method: 'POST',
    //     body: { department: "BIZC", loginID: loginId, password: password, status: "Active" }
    // },
    //     (data) => {
    //         console.log('Create User IGW => ', data);
    //         if (data.error) {
    //             setIsLoading(false);
    //             ErrorHandling(data, setErrorAPIMessage, setModalIsOpenError);
    //         }
    //         else databaseAPI(); //database pic_users create
    //     }, (fail) => {
    //         console.log('fail => ', fail);
    //         setErrorAPIMessage("Please try again. Error: " + fail.result);
    //         setModalIsOpenError(true);
    //     }
    // );
    // // }

    // // else {
    // //     setIsLoading(false);
    // //     setErrorAPIMessage("The customer with the BRN No. already exist.");
    // //     setModalIsOpenError(true);
    // // }

    // Make API calls simultaneously
    const databaseAPI = (companyName, taxIdentificationNumber, SSTNumber, ADB2C_ID) => {
      const addDb = makeAPICall(
        '/bizcareui/api/Registration/addUserDB',
        'POST',
        {
          fName: fName,
          lName: lName,
          custName: companyName,
          password: password,
          loginId: loginId,
          custId: brn.trim(),
          custEmail: email,
          custMobileNum: mobileNum,
          createdBy: loginId,
          status: "Y",
          role: "Super Admin",
          taxIdentificationNumber: taxIdentificationNumber,
          SSTNumber: SSTNumber,
          adb2c_Id: ADB2C_ID,
        },
        { 'Content-Type': 'application/json', fromReg: true }
      );

      const presetsDb = makeAPICall(
        '/bizcareui/api/Presets/upDatePresets',
        'POST',
        {
          fromReg: true,
          brn: brn.trim(),
          role: 'Super Admin', //presets already in js
          // presets: `Bulk Pay Bills,Bulk Enable Auto Billing,Bulk Disable Auto Billing,Bulk Change Bill Cycle,Bulk Change Bill Media,Bulk Change Address,Bulk SIM Replacement,Bulk Enable CallBar,Bulk Release CallBar,Bulk Change Name,
          // Edit Profile,Edit Billing information,Pay Now,Change Bill Cycle,Change Bill Settings,Manage Credit limit,Manage Temporary credit limit,Call Bar,Release/ Release Call bar,SIM/ eSim,Manage Add Ons/ Solution,Manage Internet,
          // Intershare,Pay Bills,Auto Billing,View History,Create Admin,Create Group,Assign Number,Unassign Number,Reassign Number`
          //     presets: `Create Asst Group Admins,Reactive Suspend Line,Manage Sim,Create Group Admins,Edit VAS,InterShare,
          //   Direct Debit,Edit Bill Cycle,Edit Bill Address,Manage Quota,Edit Admin Presets,Pay Bills,Manage Quota InterShare,Intershare Quota,
          //   Debit,Edit Address,View VAS,View Bills,Edit Account Details`
        }
      );

      // Wait for both API calls to complete
      Promise.all([addDb, presetsDb])
        .then(([response1, response2]) => {
          if (response1.result === 'Created successfully') {
            emailTrigger();
          } else {
            setIsLoading(false);
            // console.log("pic users db", response1)
            // console.log("presets ", response2)
            setErrorAPIMessage(
              'Request failed. User not created in Portal.'
            );
            setModalIsOpenError(true);
          }
          setTacAgain(false);
        })
        .catch((error) => {
          setIsLoading(false);
          console.error('Error:', error);
          setErrorAPIMessage('Please try again. Error ', error);
          setModalIsOpenError(true);
        });
    };

    // const databaseAPI = () => {
    //     sendTaskRequestUserAddDb(
    //         {
    //             url: '/bizcareui/api/Registration/addUserDB',
    //             method: 'POST',
    //             body: { fName: fName, lName: lName, loginId: loginId, custId: brnCustRet, custEmail: email, custMobileNum: mobileNum, createdBy: loginId, status: "Y" },
    //             headers: {
    //                 // Authorization: urlLink,
    //                 "Content-Type": "application/json"
    //             },
    //         }, (data) => {
    //             const { result } = data;
    //             console.log('database => ', result);
    //             if (result === "Created successfully") {
    //                 // setModalIsOpenBulk(true);
    //                 emailTrigger();
    //                 // reset();
    //                 // setScreenName('login');
    //             }
    //             else if (result === "Failed to load data") {
    //                 setErrorAPIMessage("Request failed. Please check your internet connection or  VPN connection.");
    //                 setModalIsOpenError(true);
    //             }
    //             setTacAgain(false);
    //         }, (fail) => {
    //             console.log('fail => ', fail);
    //             setErrorAPIMessage("Please try again. Error: " + fail);
    //             setModalIsOpenError(true);
    //         }
    //     )
    // }

    const emailTrigger = async () => {
      let subject = 'CelcomDigi BizCare Portal â€“ Login ID Registration Status';
      let body = 'type1';
      let celShortMessage = `Your Login ID has been successfully registered. Kindly visit your email for further details.<br/>Thank You.`;

      const payload = {
        loginId: loginId,
        password: password,
        // email
        body: body,
        recepientEmail: email,
        subject: subject,
        mobileNo: mobileNum,
        brn: brn.trim(),
        // sms
        celDestinationAddr: mobileNum,
        celEventName: subject,
        celShortMessage: celShortMessage,
      };

      let response = await fetch(`/bizcareui/api/emailAndSms`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          fromReg: true,
        },
        body: JSON.stringify(payload),
      });

      let data = await response.json();
      // console.log(data);
      setIsLoading(false);

      // const x = useSelector((state) => state.GetTAC?.getTACNo);
      // console.log(x);

      if (
        data?.resultEmail?.status === 'OK' &&
        data?.resultSms === ''
      ) {
        setModalIsOpenBulk(true);
      } else
        console.log('error. email or sms has not been sent due to api error.');
    };

    createUserAndCompanyName();
  };

  const handleSubmitEmailNotExist = async (brn) => {
    // console.log("handleSubmitEmailNotExist");
    setIsLoading(true);

    // // get max db number for loginId + 1
    // const max = await fetch("/bizcareui/api/Registration/loginId");
    // const maxNum = await max.json();
    // const loginId = "BIZC1000" + (maxNum.result[0].sequenceNum + 1)
    // const loginId = await LoginIdGenerator();
    // console.log("loginId", loginId);

    const createWorkItem = (documentRefId, custId, companyName) => {

      var payload = {
      // action: 'CREATEWORKITEM',
      relatedParty: [
        {
          referredType: "User",
          id: process.env.NEXT_PUBLIC_USER_ID
      },
      {
          referredType: "Customer",
          id: custId
      },
      {
          referredType: "Account",
          id: "A201348015"
      },
      {
          referredType: "SubscriberAccount",
          id: email
      }
      ],

      //  userId: email, 'V11122X@celcom.com.my'
        category: 'REG_BIZCARE',
        workType: 'NEW_REG_BIZCARE',
        workSubType: 'NEW_REG_BIZCARE_LOGIN',
        workOrderItem: [ 
          {
            work: {
              type: "WorkRefOrValue", 
              workCharacteristic: [
                {
                  name: "firstName",
                  value: fName
              },
              {
                  name: "lastName",
                  value: lName
              },
              {
                  name: "emailId",
                  value: email
              },
              {
                  name: "mobileNumber",
                  value: mobileNum
              },
              {
                  name: "docRefId",
                  value: documentRefId
              },
              {
                name: "companyName",
                value: companyName
              },
              {
                name: "brnNo",
                value: brn.trim()
              }

              ]
            }
          }
        ]
      };

      sendTaskRequestCreateWorkItem(
        {
          url: '/bizcareui/api/createWorkItem',
          method: 'POST',
          headers: { fromReg: true },
          body: payload,
        },
        (data) => {
          // console.log('Work item => ', data);
          setIsLoading(false);
          if (data.error) {
            setIsLoading(false);
            ErrorHandling(data, setErrorAPIMessage, setModalIsOpenError);
          } else {
            console.log(data,"DATA");
            setWorkItemId(data.success);
            // databaseAPI();
            setModalIsOpenBulk(true);
            setTacAgain(false);
          }
        },
        (fail) => {
          // if (fail.error === "Rate limit exceeded") {
          //     setErrorAPIMessage(process.env.NEXT_PUBLIC_rate_limit)
          //     setModalIsOpenError(true);
          // } else {
          //     setErrorAPIMessage("Please try again. Error: " + fail);
          //     setModalIsOpenError(true);
          // }
          // before this in databaseAPI();
          setTacAgain(false);
          ErrorHandling(fail, setErrorAPIMessage, setModalIsOpenError(true));
        }
      );

      // const databaseAPI = () => {
      //     sendTaskRequestUserAddDb(
      //         {
      //             url: '/bizcareui/api/Registration/addUserDB',
      //             method: 'POST',
      //             body: { fName: fName, lName: lName, loginId: loginId, custId: brn, custEmail: email, custMobileNum: mobileNum, createdBy: null, status: "N", password: null, role: "Super Admin" },
      //             headers: {
      //                 "Content-Type": "application/json"
      //             },
      //         }, (data) => {
      //             const { result } = data;
      //             // console.log('database => ', result);
      //             setIsLoading(false);

      //             if (result === "Created successfully") {
      //                 setModalIsOpenBulk(true);
      //             }
      //             else if (result === "Failed to load data") {
      //                 setErrorAPIMessage(result, "Please check your connection.");
      //                 setModalIsOpenError(true);
      //                 // console.log("Status database:", result, "Please check your connection.");
      //             }
      //             setTacAgain(false);
      //         }, (fail) => {
      //             setIsLoading(false);
      //             // console.log('fail => ', fail);
      //             setErrorAPIMessage("Please try again. Error: " + fail.result);
      //             setModalIsOpenError(true);
      //             setTacAgain(false);
      //         }
      //     )
      // }
    };

    // const emailTrigger = async (loginId) => {
    //     // console.log("email trigger");

    //     let subject = "Celcom BizCare Portal - Login Status";
    //     let body = "type2"
    //     let celShortMessage = `Your Login ID for ${loginId} has been successfully registered. Kindly visit your email for further details.<br/>Thank You.`;

    //     const payload = {
    //         loginId: loginId,
    //         // email
    //         body: body,
    //         recepientEmail: email,
    //         subject: subject,
    //         // sms
    //         celDestinationAddr: mobileNum,
    //         celEventName: subject,
    //         celShortMessage: celShortMessage,
    //     }

    //     let response = await fetch(`/bizcareui/api/emailAndSms`, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //             fromReg: true,
    //         },
    //         body: JSON.stringify(payload),
    //     });

    //     let data = await response.json();
    //     // console.log(data);
    //     setIsLoading(false);

    //     if (data.resultEmail.status === 'OK' && data.resultSms.status === 'Success') {
    //         setModalIsOpenBulk(true);
    //     }
    //     else console.log("error. email or sms has not been sent due to api error.");
    // }

    //database user_role_group_map
    // const addUserInRoleGroupMap = async (info, companyName) => {
    //     sendTaskRequestDBCompany(
    //         {
    //             url: '/bizcareui/api/manageCompany/addCompany',
    //             method: 'POST',
    //             body: {
    //                 fromReg: true,
    //                 loginUser: info[0].loginId,
    //                 custid: info[0].custId,
    //                 custName: companyName,
    //                 group: "",
    //                 Role: "Super Admin",
    //                 createId: info[0].loginId,
    //             },
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //         },
    //         (data) => {
    //             if (data.result === 'Created Successfully') {
    //                 setEmailExist(true);
    //                 emailTrigger(info[0].loginId);
    //             } else {
    //                 setIsLoading(false);
    //                 ErrorHandling(data, setErrorAPIMessage);
    //             }
    //         },
    //         (fail) => {
    //             setIsLoading(false);
    //             // console.log('fail => ', fail);
    //             setErrorAPIMessage(fail);
    //             setModalIsOpenError(true);
    //         }
    //     );
    // };
   
     const fetchDocRefId = async (custId, companyName) => {
      const channelSourceID = await generateUniqueId();

      var request = {
        channelId: "BZC",
        documents: [
          {
            properties: {
              channelSource: channelSourceID,
              documentFileName: fileName, // "FileName with extension(only - & _ special characters accepted with    jpg,.gif,.png,.pdf,.xlsx,.docx,.ppt,.html,.txt,.zip.)",
              documentType: "LOA",
            },
            base64Document: pdfValue,
          },
        ],
      };

      sendTaskRequestDocRef(
        {
          url: '/bizcareui/api/fileupload',
          method: 'POST',
          headers: { fromReg: true },
          body: request,
        },
        (data) => {
          // console.log('Doc ref => ', data);
          if (data.error) {
            setIsLoading(false);
            ErrorHandling(data, setErrorAPIMessage, setModalIsOpenError);
            return;
          }
          console.log(
            "documentRefId",
            data?.data[0]?.properties,
            data?.data[0]?.properties?.channelSource
          );
          const documentRefId = data?.data[0]?.properties.channelSource;
          // already check at RequestTAC, here just execute
          // if (!userPic)
          createWorkItem(documentRefId, custId, companyName);
          // else if (userPic && !roleGroupMap) {
          //     addUserInRoleGroupMap(info, companyName);
          // }
          //else {
          //     setIsLoading(false);
          //     setErrorAPIMessage("The customer with the BRN No. already exist.");
          //     setModalIsOpenError(true);
          // }
        },
        (fail) => {
          setIsLoading(false);
          ErrorHandling(fail, setErrorAPIMessage, setModalIsOpenError(true));
          // if (fail.error === "Rate limit exceeded") {
          //     setErrorAPIMessage(process.env.NEXT_PUBLIC_rate_limit)
          //     setModalIsOpenError(true);
          // } else {
          //     setErrorAPIMessage("Please try again. Error: " + fail);
          //     setModalIsOpenError(true);
          // }
        }
      );

      // const res = await fetch(`/bizcareui/api/documentUpload`, {
      //     method: "POST",
      //     body: JSON.stringify(request),
      // });
      // const result1 = await res.json();
      // const documentrefId = await result1?.data[0]?.docReferenceId;
      // setIsLoading(false);
      // return documentrefId;
    };

    // const getCustIdAPI = async () => {
    //     sendTaskRequestGetCustId({
    //         url: '/bizcareui/api/getCustId',
    //         method: 'POST',
    //         body: { brn: brn } //54632432
    //     },
    //         (data) => {
    //             console.log('Cust Id: => ', data);
    //             if (data.error) {
    //                 setIsLoading(false);
    //                 setErrorAPIMessage("Please use a valid BRN");
    //                 setModalIsOpenError(true);
    //                 // ErrorHandling(data, setErrorAPIMessage, setModalIsOpenError);
    //                 setResetSingle(true);
    //                 setBrn(""); //reset brn
    //             }
    //             else fetchDocRefId(data.customerIds[0]);
    //         }, (fail) => {
    //             setIsLoading(false);
    //             console.log('fail => ', fail);
    //             setErrorAPIMessage("Please try again. Error: " + fail);
    //             setModalIsOpenError(true);
    //         }
    //     );
    // }

    const getCustIdAPI = makeAPICall(
      '/bizcareui/api/getCustId',
      'POST',
      { brn: brn.trim() },
      { 'Content-Type': 'application/json', fromReg: true }
    );
    // const encrypted_textBRN = crypt(
    //     process.env.NEXT_PUBLIC_ENCRYPTION_KEY,
    //     CustID
    // );

    const getCompanyNameAPI = makeAPICall(
      '/bizcareui/api/celcomAdmin/activeBrns',
      'POST',
      { brn: [`${brn.trim()}`] },
      { fromReg: true }
    );

    // Make API calls simultaneously
    const getCustIdAndCompany = () => {
      Promise.all([getCustIdAPI, getCompanyNameAPI])
        .then(([response1, response2]) => {
          // console.log(response1);
          // console.log(response2);

          const customerId = response1?.customerId;
          // const customerName = response2?.customerData?.[0]?.customerName;
          const customerName = response2?.party[0]?.customerName;

          // console.log(customerId, " ", customerName);

          if (customerId && customerName) {
            fetchDocRefId(customerId, customerName);
          } else if (!customerId || !customerName) {
            setIsLoading(false);
            // console.log("get customer id ", response1)
            // console.log("get company name  ", response2)
            setErrorAPIMessage('The customer with the BRN No. does not exist');
            setModalIsOpenError(true);
          } else {
            setIsLoading(false);
            // console.log("get customer id ", response1)
            // console.log("get company name  ", response2)
            setErrorAPIMessage(
              'Request failed. Please check your internet connection or  VPN connection.'
            );
            setModalIsOpenError(true);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          setErrorAPIMessage('Please try again. Error ', error);
          setModalIsOpenError(true);
        });
    };

    // getCustIdAPI();
    getCustIdAndCompany();
  };
  const serviceNumberCheck = async (mobileNum) => {
    seviceNumberApiCheck(
      {
        url: `/bizcareui/api/Registration/ServiceNumberApi?serviceNumber=${mobileNum}`,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          fromReg: true,
        },
      },
      (data) => {
        const result = data?.jsonData?.siebelOnlineStoreCheckResp;
        // console.log("data in registration", result.errorCode);
        if (data.error) {
          ErrorHandling(data, setErrorAPIMessage);
        } else if (data === undefined || data.length === 0) {
          setErrorAPIMessage('Data not found');
        } else if (result === undefined || result.length === 0) {
          setErrorAPIMessage('Data not found');
        }
        // Err40066
        else if (
          result.errorCode === 'Err40066' &&
          result.errorMessage === 'Service number already exists'
        ) {
          setResetSingle(true);
          setTacStatus(true);
          setTacAgain(true);
          setForceTimerGone(false);
          setTimerReset(true);
          const tacNumber = randomNumberInRange(100000, 999999);
          setGetTAC(tacNumber);
          checkEmail(email, brn, tacNumber, mobileNum);
        } else {
          setTacAgain(false);
          setErrMobileNum('Please enter a registered Celcom number');
        }
      },
      (fail) => {
        if (fail?.error === process.env.NEXT_PUBLIC_RateLimitError) {
          ErrorHandling(fail, setErrorAPIMessage, setModalIsOpenError);
        } else {
          ErrorHandling(
            fail,
            setErrorAPIMessage,
            setModalIsOpenError,
            process.env.NEXT_PUBLIC_api_failure
          );
        }
      }
    );
  };
  // validation here
  const checkEmail = async (email, brn, tacNumber, mobileNum) => {
    let lowerCaseEmail = email.toLowerCase();
    setIsLoading(true);

    // check email duplicacy with crms
    const emailCheckWithCrms = async () => {
      sendTaskRequestCheckEmailAPI(
        {
          url: '/bizcareui/api/RegisterCheckEmail',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            fromReg: true,
          },
          // body: { brn: "54632432", email: "newEmail@gmail.com" } //54632432
          body: {
            brn: brn.trim(),
            email: lowerCaseEmail,
            reason: 'CheckDuplicacy',
          }, //54632432
        },
        (data) => {
          // console.log('Email status: => ', data);
          if (data.error) {
            ErrorHandling(data, setErrorAPIMessage, setModalIsOpenError);
          } else {
            setEmailExist(data);
            // console.log("emailExist", emailExist);

            // if (data === true) console.log("Email exist");
            // else if (data === false) console.log("New email registered");

            fetchTAC(tacNumber);
          }
        },
        (fail) => {
          // console.log('fail => ', fail);
          setErrorAPIMessage('Please try again. Error: ' + fail);
          setModalIsOpenError(true);
        }
      );
    };

    // // check email duplicacy with db user role group map
    // const checkInRoleGroupMapDB = async (info, role, groups) => {
    //     let response = await fetch('/bizcareui/api/createAdmin/createAdmin', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify({
    //             fromReg: true,
    //             loginId: info[0].loginId,
    //             custId: info[0].custId,
    //             Role: role,
    //             Group: groups,
    //         }),
    //     });
    //     let { result, error } = await response.json();
    //     setIsLoading(false);

    //     if (result === 'The data already exist') {
    //         console.log('User already exist');
    //         setErrorAPIMessage("The customer with the BRN No. already exist.");
    //         setModalIsOpenError(true);
    //         setEmail('');
    //         setRoleGroupMap(true);
    //     } else if (result === 'Not exist') {
    //         console.log('User not exist in user_role_group_map table');
    //         setRoleGroupMap(false);
    //         emailCheckWithCrms();
    //     }
    //     else {
    //         setRoleGroupMap(false);
    //         setErrorAPIMessage(error);
    //         setModalIsOpenError(true);
    //     }
    // };

    // check email duplicacy with db pic users
    // const res = await fetch(`/bizcareui/api/createAdmin/createAdmin`, {
    const res = await fetch(`/bizcareui/api/Registration/loginId`, {
      method: 'PUT',
      // body: JSON.stringify({ fromReg: true, custEmail: lowerCaseEmail, brn: brn, role: "Super Admin" }),
      body: JSON.stringify({ fromReg: true, custEmail: lowerCaseEmail }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const { result } = await res.json();
    setIsLoading(false);
    // if (result.length > 0) {
    if (result === 'Success, new email registered') {
      // const role = "Super Admin";
      // const group = "";
      // checkInRoleGroupMapDB(result, role, group);
      // setInfo(result);
      emailCheckWithCrms();
      // setUserPic(true);
    } else {
      // setErrorAPIMessage("The customer with the BRN No. already exist.");
      setErrorAPIMessage('The Email Id is already being used.');
      setModalIsOpenError(true);
      setEmail('');
      // setUserPic(false);
      // setRoleGroupMap(false);
    }
  };

  const fetchTAC = async (tacNumber) => {
    // const tac = { message: tacNumber };
    const secretKey = process.env.NEXT_PUBLIC_TAC;

    // const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(tac), secretKey).toString();
    const encryptedData = crypt(secretKey, tacNumber.toString());
    sendTaskRequestTAC(
      {
        url: '/bizcareui/api/emailAndSms',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          fromReg: true,
        },
        body: {
          type: 'TAC',
          mobileNum: mobileNum,
          tacNumber: encryptedData,
        },
      },
      (data) => {
        const result = data;
        if (result.resultSms === '') {
          // console.log("Result TAC sent: ", result.resultSms);
          setResetSingle(false);
        } else {
          setIsLoading(false);
          if (result.status === 'Failed') {
            // console.log("Result TAC sent: ", result.status);
            setErrorAPIMessage(
              'Send TAC is failed. Please enter a valid phone number.'
            );
            setModalIsOpenError(true);
          }

          ErrorHandling(result, setErrorAPIMessage, setModalIsOpenError);

          setGetTAC(0);
          setTacAgain(false);
          setForceTimerGone(true);
        }
      },
      (fail) => {
        // console.log('fail => ', fail);
        setErrorAPIMessage('Please try again. Error: ' + fail);
        setModalIsOpenError(true);

        setGetTAC(0);
        setTacAgain(false);
        setForceTimerGone(true);
      }
    );
  };

  const getPICUsers = async (email, emailExist, fileBrowse, brn) => {
    // console.log("get pic users function. email exist=>", emailExist);
    if (emailExist) handleSubmitEmailExist(brn);
    else if (!emailExist && fileBrowse) handleSubmitEmailNotExist(brn);
    else if (!emailExist && !fileBrowse)
      setErrFileBrowse('Please upload the file');
  };

  const popoverRulePassword = (
    <Popover
      id="popover-trigger-click-root-close"
      className={styles.popOverComponent}
      title="Popover bottom"
    >
      <div className={styles.popOver}>
        <li id={errPasscodeRule[0].char ? styles.textRed : styles.textGreen}>
          <span
            className={styles.bullet}
            id={
              errPasscodeRule[0].char
                ? styles.bulletColorRed
                : styles.bulletColorGreen
            }
          ></span>
          Be at least 8 characters
        </li>
        <li id={errPasscodeRule[0].capLet ? styles.textRed : styles.textGreen}>
          <span
            className={styles.bullet}
            id={
              errPasscodeRule[0].capLet
                ? styles.bulletColorRed
                : styles.bulletColorGreen
            }
          ></span>
          Have at least one Capital letter
        </li>
        <li id={errPasscodeRule[0].smLet ? styles.textRed : styles.textGreen}>
          <span
            className={styles.bullet}
            id={
              errPasscodeRule[0].smLet
                ? styles.bulletColorRed
                : styles.bulletColorGreen
            }
          ></span>
          Have at least one Small letter
        </li>
        <li id={errPasscodeRule[0].minNum ? styles.textRed : styles.textGreen}>
          <span
            className={styles.bullet}
            id={
              errPasscodeRule[0].minNum
                ? styles.bulletColorRed
                : styles.bulletColorGreen
            }
          ></span>
          Have at least one Number
        </li>
        <li
          id={errPasscodeRule[0].minSym ? styles.textRed : styles.textGreen}
          className="mb-0"
        >
          <span
            className={styles.bullet}
            id={
              errPasscodeRule[0].minSym
                ? styles.bulletColorRed
                : styles.bulletColorGreen
            }
          ></span>
          Have at least one symbol
        </li>
      </div>
    </Popover>
  );

  const reset = () => {
    setFName('');
    setLName('');
    setEmail('');
    setMobileNum('');
    setTacReq('');
    setBrn('');
    setFileBrowse('');
    setTacAgain(false);
    setTacStatus(false);
    setEmailExist(false);
    // setBrnComparingStart(false);
    document.getElementById('agree').checked = false;
  };

  return (
    <div className={styles.overflow}>
      <LoadingDailog isLoading={isLoading || loading1} />
      <ErrorApiPopup
        modalIsOpenError={modalIsOpenError}
        errorAPIMessage={errorAPIMessage}
        clickOKHandler={() => {
          setModalIsOpenError(false);
          if (resetSingle) {
            setTacAgain(false);
            setGetTAC(0);
            setTacStatus(false);
          } else reset();

          setResetSingle(false);
          setTacReq('');
        }}
      />
      {/* <RegistrationPopup emailExist={emailExist} screen="Registration" clickHandler={() => reset()} /> */}
      <BulkReceiptReact
        modalIsOpenBulk={modalIsOpenBulk}
        clickButtonHandler={() => {
          setModalIsOpenBulk(false);
          reset();
          setScreenName('login');
        }}
        text="Thank you for Registering!"
        Requestedmessage={
          !emailExist
            ? `The form with Work Item Id ${workItemId} has been submitted successfully and currently it is under approval process. You will receive an email soon for further instruction.`
            : 'The form has been submitted successfully. Please check your email for confirmation.'
        }
      />
      <TermsConditions
        modalIsOpenTNC={modalIsOpenTNC}
        setModalIsOpenTNC={setModalIsOpenTNC}
      />
      <div className={styles.formReg}>
        <div className="d-flex flex-row justify-content-between">
          <div id={styles.fileVisibility} className="my-auto">
            <label className={styles.createLabel} htmlFor={`AccountCreate`}>
              Ready to create an account?
            </label>
            <input type="text" id={`AccountCreate`} className="noneClass" />
            <div className={styles.verifyLabel}>
              Before that, let us verify your details.
            </div>
          </div>
          <CelcomLogo id={styles.logoVisibility} />
        </div>
        <hr
          id={styles.fileVisibility}
          className={`reghr my-2 ${styles.hr}`}
        ></hr>
        <div>
          <div className={styles.chooseLabel}>Super Admin Registration</div>
          <div className={`${styles.question} ${styles.helpPIC}`}>
            <label
              className="font-weight-bold mb-0 text-dark"
              htmlFor={`adminRegistration`}
            >
              Super Admin :{' '}
            </label>{' '}
            <input type="text" id={`adminRegistration`} className="noneClass" />
            Person in Charge (PIC) of the company, who needs to manage overall
            account under company BRN.
          </div>
          <div>
            <div className="form-group d-flex flex-wrap mb-0">
              <div className={`w-100 d-flex ${styles.inputWidth}`}>
                <TextField
                  id="fname"
                  name="fname"
                  label="First Name"
                  autofocus={true}
                  value={fName}
                  onChange={(e) => {
                    setFName(e.target.value);
                    // setFName(e.target.value.toLowerCase().replace(/\b\w/g, (word) => word.toUpperCase()));
                    if (!e.target.value)
                      setErrFName('Please enter the valid First Name');
                    // else if (!/^[a-zA-Z']+[ a-zA-Z.@'\/]*[a-zA-Z'.]$/.test(e.target.value)) setErrFName('Please enter the valid First Name');
                    else if (
                      !/^[a-zA-Z'\-\\]+[ a-zA-Z.@'\/\\]*[a-zA-Z'.\\]$/.test(
                        e.target.value
                      )
                    )
                      setErrFName('Please enter the valid First Name');
                    else setErrFName('');
                  }}
                  error={errFName}
                  className="ml-0 mr-5"
                  required={true}
                />
                <TextField
                  id="lname"
                  name="lname"
                  label="Last Name"
                  value={lName}
                  onChange={(e) => {
                    setLName(e.target.value);
                    // setLName(e.target.value.toLowerCase().replace(/\b\w/g, (word) => word.toUpperCase()));
                    if (!e.target.value)
                      setErrLName('Please enter the valid Last Name');
                    // else if (!/^[a-zA-Z']+[ a-zA-Z.@'\/]*[a-zA-Z']$/.test(e.target.value)) setErrLName('Please enter the valid Last Name');
                    else if (
                      !/^[a-zA-Z'\-,\\]+[ a-zA-Z.@'\/\\]*[a-zA-Z'\-,\\]$/.test(
                        e.target.value
                      )
                    )
                      setErrLName('Please enter the valid Last Name');
                    else setErrLName('');
                  }}
                  error={errLName}
                  className="ml-0"
                  required={true}
                />
              </div>
              {/* <div className={`w-100 d-flex ${styles.inputWidth}`}>
                                <OverlayTrigger
                                    trigger={['hover', 'focus', 'click']}
                                    rootClose={true}
                                    placement="bottom"
                                    overlay={popoverRulePassword}
                                    className="m-0"
                                >
                                    <div className={`form-group ml-0 mr-5`} >
                                        <input
                                            id="password"
                                            type="password"
                                            value={passcode}
                                            onChange={e => {
                                                setPasscode(e.target.value);
                                               
                                                if (!e.target.value) {
                                                    setErrPasscodeRule([{ char: true, capLet: true, smLet: true, minNum: true, minSym: true }]);
                                                    setErrPasscode("false");
                                                }
                                                if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(e.target.value)) {
                                                    const originalData = [...errPasscodeRule];

                                                    if (e.target.value.length < 8) originalData[0].char = true;
                                                    else originalData[0].char = false;

                                                    if (!/(?=.*[A-Z])(?=.{1,})/.test(e.target.value)) originalData[0].capLet = true;
                                                    else originalData[0].capLet = false;

                                                    if (!/(?=.*[a-z])(?=.{1,})/.test(e.target.value)) originalData[0].smLet = true;
                                                    else originalData[0].smLet = false;

                                                    if (!/(?=.*[0-9])(?=.{1,})/.test(e.target.value)) originalData[0].minNum = true;
                                                    else originalData[0].minNum = false;

                                                    if (!/(?=.*[!@#$%^&*])(?=.{1,})/.test(e.target.value)) originalData[0].minSym = true;
                                                    else originalData[0].minSym = false;

                                                    setErrPasscodeRule(originalData);
                                                    setErrPasscode("false");
                                                }
                                                else {
                                                    setErrPasscodeRule([{ char: false, capLet: false, smLet: false, minNum: false, minSym: false }]);
                                                    setErrPasscode("");
                                                }
                                            }}
                                            name="password"
                                            className={errPasscode ? "form-control border border-danger" : "form-control"}
                                            placeholder=" "
                                            required={true}
                                        />
                                        <label htmlFor="password" className="text-muted">Password<span className="text-danger"> *</span></label>
                                       
                                    </div>
                                </OverlayTrigger>
                                <TextField
                                    id="confirmPassword"
                                    type="password"
                                    name="confirmPassword"
                                    label="Confirm Password"
                                    value={passcodeConfirm}
                                    onChange={e => {
                                        setPasscodeConfirm(e.target.value);
                                        if (!e.target.value) setErrPasscodeConfirm("Please enter the password");
                                        else if (e.target.value !== passcode) setErrPasscodeConfirm("Password does not match");
                                        else setErrPasscodeConfirm("");
                                    }}
                                    error={errPasscodeConfirm}
                                    className="ml-0 mr-0"
                                    required={true}
                                />
                            </div> */}
              <div className={`w-100 d-flex ${styles.inputWidth}`}>
                <TextField
                  id="email"
                  type="email"
                  // name="email"
                  label="Email"
                  value={email}
                  maxLength="128"
                  onChange={(e) => {
                    setEmail(e.target.value);
                    // setEmail(e.target.value.toLowerCase());

                    // will be checked after clicked Register button
                    // const emailExistCheck = allEmailData.filter((emailData) => { if (emailData && (e.target.value.toLowerCase() === emailData.toLowerCase())) return emailData });

                    // const loginIdExistCheck = allEmailData.filter((emailData) => {
                    //     var dbEmailSplit = emailData && emailData.split("@");
                    //     var dbEmailName = dbEmailSplit && dbEmailSplit[0];
                    //     let dbLoginId = dbEmailName;

                    //     var inputEmailSplit = e.target.value && e.target.value.split("@");
                    //     var inputEmailName = inputEmailSplit && inputEmailSplit[0];
                    //     let inputLoginId = inputEmailName;

                    //     if (inputLoginId === dbLoginId) return loginId;
                    // });

                    if (!e.target.value)
                      setErrEmail('Please enter the valid Email');
                    else if (
                      !/[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}/.test(
                        e.target.value
                      )
                    )
                      setErrEmail('Please enter the valid Email');
                    // else if (emailExistCheck.length === 1) setErrEmail("This email already been used"); // will be checked after clicked Register button
                    // else if (loginIdExistCheck.length === 1) setErrEmail("This login id already exist");
                    else setErrEmail('');

                    // check whether user need to upload LOA or not
                    // const dummyEmailCheck = dummyEmail.filter((dummyEmail) => { if (e.target.value.toLowerCase() === dummyEmail.email.toLowerCase()) return dummyEmail.email });
                    // if (dummyEmailCheck?.length === 1) { setEmailExist(true) }
                    // else setEmailExist(false);
                  }}
                  error={errEmail}
                  className={`ml-0 mr-5 ${tacAgain && styles.opacityField}`}
                  required={true}
                  disable={tacAgain}
                />
                <TextField
                  id="brn"
                  type="text"
                  // type="tel"
                  // maxLength="13"
                  name="brn"
                  label="BRN No."
                  value={brn}
                  onChange={(e) => {
                    setBrn(e.target.value);
                    if (!e.target.value)
                      setErrBrn('Please enter the valid BRN No.');
                    // else if (!/^[a-zA-Z0-9_]+$/.test(e.target.value)) setErrBrn('Please enter the valid BRN No.');
                    // else if (/^[a-zA-Z0-9!@#$&()\\-`.+,/\"]*$/.test(e.target.value)) setErrBrn('Please enter the valid BRN No.');
                    else if (
                      !/^[ A-Za-z0-9_/&!#@$%()~-]+$/.test(e.target.value)
                    )
                      setErrBrn('Please enter the valid BRN No.');
                    else setErrBrn('');
                  }}
                  error={errBrn}
                  className={`${styles.inputBRN} ml-0 ${
                    tacAgain && styles.opacityField
                  }`}
                  required={true}
                  disable={tacAgain}
                />
              </div>
              <div className={`w-100 d-flex ${styles.inputWidth}`}>
                <TextField
                  id="mobile"
                  type="tel"
                  maxLength="12"
                  name="mobile"
                  label="Mobile"
                  value={mobileNum}
                  onChange={(e) => {
                    setMobileNum(e.target.value);
                    if (!e.target.value)
                      setErrMobileNum('Please enter the valid Mobile');
                    // else if (!/(\+?01)[02-46-9]-*[0-9]{7}$|^(\+?01)[1]-*[0-9]{8}/.test(e.target.value)) setErrMobileNum("Please enter a valid Mobile");
                    else if (
                      !/^(01)[02-46-9]-*[0-9]{7}$|^(01)[1]-*[0-9]{8}/.test(
                        e.target.value
                      )
                    )
                      setErrMobileNum('Please enter the valid Mobile');
                    else setErrMobileNum('');
                  }}
                  error={errMobileNum}
                  className={`ml-0 mr-5 ${tacAgain && styles.opacityField}`}
                  required={true}
                  disable={tacAgain}
                />

                {/* <div className="d-flex gap-2"> */}

                <div className={styles.divTAC}>
                  <div className="my-auto">
                    <button
                      type="button"
                      className={`${styles.reqTAC} ${
                        tacAgain
                          ? styles.btnTACDisable
                          : `${styles.btnTAC} ${styles.focusOutlined}`
                      }`}
                      disabled={tacAgain}
                      onClick={() => {
                        setTacReq('');
                        if (
                          mobileNum &&
                          errMobileNum === '' &&
                          brn &&
                          errBrn === '' &&
                          email &&
                          errEmail === ''
                        ) {
                          if (
                            process.env.NEXT_PUBLIC_ENV_SERVICENO_KEY === 'Y'
                          ) {
                            serviceNumberCheck(mobileNum);
                          } else {
                            setResetSingle(true); //tac func
                            setTacStatus(true); //tac disabled
                            setTacAgain(true); //timer
                            setForceTimerGone(false);
                            // resendOTP();
                            setTimerReset(true);
                            const tacNumber = randomNumberInRange(
                              100000,
                              999999
                            );
                            // console.log("TAC Number::", tacNumber)
                            // const tacNumber = 123456;
                            setGetTAC(tacNumber);
                            // fetchTAC(tacNumber);
                            // console.log(tacNumber);
                            checkEmail(email, brn, tacNumber, mobileNum);
                          }
                        } else {
                          if (!email)
                            setErrEmail(
                              `Please insert email before request TAC`
                            );
                          if (!mobileNum)
                            setErrMobileNum(
                              `Please insert Mobile before request TAC`
                            );
                          if (!brn)
                            setErrBrn(
                              `Please insert BRN No. before request TAC`
                            );
                        }
                      }}
                    >
                      Request TAC
                    </button>
                  </div>
                </div>
                {/* 
                                    <div className={`w-100 d-flex ${styles.inputWidth}`}>
                                        <TextField
                                            id="tac"
                                            type="tel"
                                            maxLength="6"
                                            name="tac"
                                            label="TAC"
                                            value={tacReq}
                                            onBlur={e => {
                                                if (!e.target.value) setErrTacReq("Please enter the valid TAC");
                                                else if (!/[0-9]{6}/.test(e.target.value)) setErrTacReq("Please enter the valid TAC");
                                                else setErrTacReq("");
                                            }}
                                            onChange={e => {
                                                setTacReq(e.target.value);
                                                if (e.target.value || /[0-9]{6}/.test(e.target.value)) setErrTacReq("");
                                                console.log("This is the TAC", getTAC);
                                            }}
                                            onKeyPress={(e) => {
                                                if (!/[0-9]/.test(e.key)) e.preventDefault();
                                            }}
                                            error={errTacReq}
                                            className={`ml-0 w-100`}
                                            disable={!tacStatus}
                                            required={true}
                                        />
                                    </div>
                                </div> */}
              </div>
              <div className={`w-100 d-flex ${styles.inputWidth}`}>
                <TextField
                  id="tac"
                  type="tel"
                  maxLength="6"
                  name="tac"
                  label="TAC"
                  value={tacReq}
                  onBlur={(e) => {
                    if (!e.target.value)
                      setErrTacReq('Please enter the valid TAC');
                    else if (!/[0-9]{6}/.test(e.target.value))
                      setErrTacReq('Please enter the valid TAC');
                    else setErrTacReq('');
                  }}
                  onChange={(e) => {
                    // console.log(getTAC);
                    setTacReq(e.target.value);
                    if (e.target.value || /[0-9]{6}/.test(e.target.value))
                      setErrTacReq('');
                    // console.log("This is the TAC", getTAC);
                  }}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) e.preventDefault();
                  }}
                  error={errTacReq}
                  className={`ml-0 mr-5`}
                  disable={!tacStatus}
                  required={true}
                />
                <Timer
                  tacAgain={tacAgain}
                  timerReset={timerReset}
                  setTimerReset={setTimerReset}
                  setTacAgain={setTacAgain}
                  setGetTAC={setGetTAC}
                  tacStatus={tacStatus}
                  forceTimerGone={forceTimerGone}
                />
              </div>
            </div>

            {/* {/[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+\.[a-z]{2,3}/.test(email) === true && ( */}
            {/* {console.log("emailExist", emailExist)} */}
            {email && errEmail === '' && !emailExist && tacStatus ? (
              // {brn && errBrn === "" && !emailExist && brnComparingStart ? (
              <div className="mt-3">
                <p className={styles.regEmail}>
                  The email address entered is not registered with Celcom.
                  Please key in the correct email address to proceed with a new
                  email address. Kindly attach Letter of Authorization (LOA).
                </p>
                <div className={`form-group ${styles.widthFileInput}`}>
                  <div className="custom-file cursor-pointer">
                    <input
                      type="file"
                      className={`custom-file-input cursor-pointer ${styles.invisibleBox}`}
                      id="inputGroupFile01"
                      name="file"
                      onChange={(e) => {
                        // console.log(e.target.files[0]);
                        if (e.target.files[0].name) {
                          const type = e.target.files[0].type;
                          const formatType = type.split('/')[0];

                          setFileBrowse(e.target.files[0].name);
                          if (
                            e.target.files[0].type === 'application/pdf' ||
                            formatType === 'image' ||
                            formatType === 'video'
                          ) {
                            setErrFileBrowse('');
                            uploadFile(e.target.files[0]);
                          } else
                            setErrFileBrowse(
                              'Please upload documents in pdf, image or video format only.'
                            );
                        } else setErrFileBrowse('Please upload documents');
                      }}
                      error={errFileBrowse}
                    />
                    {fileBrowse ? (
                      <label
                        className="custom-file-label pl-3 cursor-pointer"
                        id={errFileBrowse ? `${styles.error}` : null}
                        htmlFor="inputGroupFile01"
                      >
                        {fileBrowse}
                      </label>
                    ) : (
                      <label
                        className="custom-file-label pl-3 cursor-pointer"
                        id={errFileBrowse ? `${styles.error}` : null}
                        htmlFor="inputGroupFile01"
                      >
                        Letter of Authorization (LOA)
                        <span className={styles.regsup}> *</span>
                      </label>
                    )}
                  </div>
                  {errFileBrowse && (
                    <div className="text-danger mt-1">{errFileBrowse}</div>
                  )}
                  <p className={styles.regEmail2}>
                    Attach any supporting documents (e.g., images, videos, PDF
                    files) to complete submission.
                  </p>
                </div>
              </div>
            ) : null}

            <div className="my-3">
              <div
                className={`custom-control custom-checkbox ${styles.marginErr}`}
              >
                <input
                  className="custom-control-input"
                  type="checkbox"
                  name="agree"
                  value={checkbox}
                  error={errCheckbox}
                  onChange={(e) => {
                    setCheckbox(e.target.checked);
                    if (!e.target.checked)
                      setErrCheckbox('Please agree to proceed');
                    else setErrCheckbox('');
                  }}
                  id="agree"
                />
                <label className="custom-control-label" htmlFor="agree">
                  I Agree with the{' '}
                  <a
                    className="text-primary"
                    onClick={() => setModalIsOpenTNC(true)}
                  >
                    Terms and Conditions
                  </a>
                  <span className={styles.regsup}> *</span>
                </label>
              </div>
              {errCheckbox && (
                <span className="text-danger">{errCheckbox}</span>
              )}
            </div>

            {/* <hr className={`reghr my-0 ${styles.line}`}></hr> */}
            <div className={styles.btnReg}>
              <OutlineButton
                className={`mr-3 ${styles.focusOutlined}`}
                name="Cancel"
                clickHandler={() => setScreenName('login')}
              />
              <FilledButton
                className={`${styles.focusFilled}`}
                name="Register"
                clickHandler={() => {
                  // console.log(((emailExist && !fileBrowse) || (!emailExist && fileBrowse)));
                  // fName && lName && passcode && passcodeConfirm && email && mobileNum && tacReq && checkbox &&
                  // errFName === "" && errLName === "" && errPasscode === "" && errPasscodeConfirm === "" && errEmail === "" && errMobileNum === "" && errTacReq === "" && errCheckbox === "") {
                  if (
                    fName !== '' &&
                    lName !== '' &&
                    email !== '' &&
                    brn !== '' &&
                    mobileNum !== '' &&
                    tacReq !== '' &&
                    checkbox &&
                    ((emailExist && !fileBrowse) ||
                      (!emailExist && fileBrowse)) &&
                    errFName === '' &&
                    errLName === '' &&
                    errEmail === '' &&
                    errBrn === '' &&
                    errMobileNum === '' &&
                    errTacReq === '' &&
                    errCheckbox === '' &&
                    errFileBrowse === ''
                  ) {
                    if (parseInt(getTAC) === parseInt(tacReq)) {
                      setErrTacReq('');
                      getPICUsers(email, emailExist, fileBrowse, brn);
                      setForceTimerGone(true);
                    } else setErrTacReq('Please enter the valid TAC');
                  } else {
                    if (!fName)
                      setErrFName('Please enter the valid First Name');
                    if (!lName) setErrLName('Please enter the valid Last Name');
                    // if (!passcode) setErrPasscode("Please enter the valid password");
                    // if (!passcodeConfirm) setErrPasscodeConfirm("Please enter the valid password confirmation");
                    if (!email) setErrEmail('Please enter the valid Email');
                    if (!brn) setErrBrn('Please enter the valid BRN No.');
                    if (!mobileNum)
                      // setErrMobileNum('Please enter the valid Mobile');
                    if (!tacReq) setErrTacReq('Please enter the valid TAC');
                    if (!fileBrowse)
                      setErrFileBrowse('Please upload the valid File');
                    if (!checkbox) setErrCheckbox('Please agree to proceed');
                  }
                }}
              />
              {/* <OutlineButton className={styles.focusOutlined} name="Cancel" clickHandler={() => setScreenName('login')} /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Registration;
